import {createCustomElement, start} from '@/common-scripts/main-script';
import Sale from './sale.vue';

// start by mount in element selector
start(Sale, {
	configStorageKey: 'trenitalia-booking-engine-config',
	elementSelector: '#trenitalia-booking-engine'
});

// define a custom element work with shadowDOM
customElements.define('trenitalia-booking', createCustomElement(Sale, {
	configStorageKey: 'trenitalia-booking-engine-config'
}));